<template>
  <Head :title="'Insights - ' + page.name" />
  
  <div class="container-fluid">
    <div class="row justify-content-center mx-4">
      <div class="col p-0"> 
        <export-charts-view :page="page" :client="client" :user="user" :connections="connections"></export-charts-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
  page: Object,
  client: Object,
  user: { type: Object, default: null },
  connections: { type: Object, default: () => ({}) }
});
</script>

